import { turboproApiLista } from '@/api/turbopro';
import type {
  ItemExcluidoApi,
  ListarItensExcluidosFiltros,
  ListarItensExcluidosResponse,
} from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarItensExcluidosApi(
  filtros: ListarItensExcluidosFiltros
): Promise<ListarItensExcluidosResponse> {
  const params = new URLSearchParams({
    agendamento_id: filtros.agendamentoId,
  });

  const resposta = await turboproApiLista<ItemExcluidoApi>(
    `Relatorios/ListarItensExcluidos?${params.toString()}`,
    { headers: getRelatoriosHeaders() }
  );
  return resposta.data ?? [];
}
